<div class="rewards-container">
    <router-outlet></router-outlet>
</div>
